export const ATTENDEE_SSO_STATUS_TEXT = {
    id: `oe.accountAdmin.attendeeSSOStatus`,
    message: 'OE Passport Attendee SSO is {suffix}',
    description: 'Label text'
};

export const AVAILABLE_CONFIGURATIONS_TEXT = {
    id: `oe.accountAdmin.availableConfigurationText`,
    defaultMessage: 'Available Configurations',
    description: 'Label text'
};

export const PROVIDER_VALIDATION_TEXT = {
    id: `oe.accountAdmin.providerValidationText`,
    defaultMessage: 'At least one Idp configuration must be enabled',
    description: 'Label text'
};

export const MANAGED_DOMAINS_TOO_LONG_ERROR_TEXT = {
    id: `oe.accountAdmin.managedDomainsTooLongText`,
    defaultMessage: 'Too long - max length is 4096 characters, commas and spaces excluded',
    description: 'Error message text'
};

export const ENFORCE_ON_ALL_EVENTS_TEXT = {
    id: `oe.accountAdmin.enforceOnAllEventsText`,
    message: '{prefix} on all events',
    description: 'Label text'
};